var $a7897057abd4dedc$exports = {};
$a7897057abd4dedc$exports = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};


export {$a7897057abd4dedc$exports as default};
//# sourceMappingURL=da-DK.mjs.map
